import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './InfoBox.scss';

/**
 * Creates a simple, clickable, info box.
 *
 * @example
 ```
 <InfoBox onClick={this.startScheme}>
 Get rich, ask me how!
 </InfoBox>
 ```
 */
const propTypes = {
  /** A class name to apply to the info box. */
  className: PropTypes.string,

  /** If we should show the error-state version of the box. */
  hasError: PropTypes.bool,

  /** What to do when the info box is clicked. */
  onClick: PropTypes.func,

  /** The content of the info box. */
  children: PropTypes.any,
};
const defaultProps = {
  className: '',
  hasError: false,
  onClick: null,
  children: null,
};

export default function InfoBox({
  className,
  hasError,
  onClick,
  children,
}) {
  return (
    <button
      type="button"
      className={classNames(
        'info-box-component',
        className,
        { 'has-error': hasError },
      )}
      onClick={onClick}
    >
      <span className="content">
        {children}
      </span>
    </button>
  );
}
InfoBox.propTypes = propTypes;
InfoBox.defaultProps = defaultProps;
